import React, { Component } from 'react';
import { Form, Button } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import { updateInPath } from '../../../../common/utils';
import { clone } from 'ramda';


class Coupon extends Component {
  constructor(props) {
    super();

    this.state = {
      coupons: ''
    };
  }

  handleChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, 'coupons', value));
  };

  handleCheckCoupons = () => {
    this.props.onSubmit(clone(this.state.coupons));
  };

  render() {
    const { t } = this.props;
    
    return  (
      <Form>
        <Form.Group>
          <Form.Input
            label={t('private:payment.coupons')}
            value={this.state.coupons}
            onChange={this.handleChange}
          />
          <Form.Field>
            <Button
              size='tiny'
              content={t('private:payment.check_coupons')}
              onClick={this.handleCheckCoupons} />
          </Form.Field>
          <Form.Field>
            {t('private:payment.golden')}
          </Form.Field>
        </Form.Group>
      </Form>
    );
  }
};

export default withNamespaces(['private'])(Coupon);



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/Coupon.js